export const DATE_FORMAT_TABLE: string = 'DD/MM/YYYY - h:mma'

export const PAGE_SIZE: number = 20
